import {put,takeLatest,call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    GET_PRODUCT_TYPE,
    GET_PRODUCT_TYPE_SUCCESS,
    GET_PRODUCT_TYPE_ERROR
}
    from "../../../actions/menu/productTypes";

function* getProductTypeSaga(action) {
    try {
        const data=yield call(productTypeService.GetProductType,action.payload)
        yield put({
            type: GET_PRODUCT_TYPE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_PRODUCT_TYPE_ERROR,error: error.data
        });
    }
}


export function* getProductTypeSagaWatcher() {
    yield takeLatest(GET_PRODUCT_TYPE,getProductTypeSaga);
}